module.exports = __webpack_public_path__ + "img/credit-card-icon-disabled.cd8437a1.svg";